import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Sample Predictive Maintenance System | Developed by Joseph McGuire</p>
      <p>
        <a href="https://github.com/joseph-c-mcguire" target="_blank" rel="noopener noreferrer">GitHub</a> | 
        <a href="https://joseph-c-mcguire.github.io/" target="_blank" rel="noopener noreferrer"> Personal Website</a> | 
        <a href="https://www.linkedin.com/in/joseph-c-mcg/" target="_blank" rel="noopener noreferrer"> LinkedIn</a>
      </p>
    </footer>
  );
};

export default Footer;